import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MultilanguageService } from '../../shared/services/multilanguage.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { AutocompletesearchComponent } from '../component/autocomplete/auto-complete.component';
import { NgClass } from '@angular/common';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-list-packages',
    templateUrl: './list-packages.component.html',
    styleUrls: ['./list-packages.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, AutocompletesearchComponent, NgClass, MatRadioGroup, MatRadioButton, TranslateModule]
})
export class ListPackagesComponent implements OnInit, OnChanges {
  fieldRequired: any;

  constructor(private _ml: MultilanguageService, private _CommonService: CommonService) { }

  @Input() packageListLabel: string;
  @Input() searchdataInput: any;
  @Input() searchFullData: any;
  @Input() searchoptionalParams: any;
  @Input() required: boolean;
  @Input() selectedValue: any;
  @Input() loadFormCheck = true;

  @Output() returnData: EventEmitter<any> = new EventEmitter();
  @Output() onSelectionChange: EventEmitter<any> = new EventEmitter();
  @Output() clearSearch: EventEmitter<any> = new EventEmitter();
  @Output() formReady: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  listPackageGroup: FormGroup = new FormGroup({
    packageSelectedControl: new FormControl('')
  });

  ngOnInit() {

    this.formReady.emit(this.listPackageGroup);

  }
  receivedData(data) {
    this.returnData.emit(data);
  }
  clearData() {
    this.clearSearch.emit();
  }

  radioChange(data) {
    this.onSelectionChange.next(data.value);
    this.required = false;
  }
  ngOnChanges() {
    // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    // Add '${implements OnChanges}' to the class.
    this.fieldRequired = this.required;
    this.listPackageGroup.patchValue({'packageSelectedControl': this.selectedValue});

  }
}
